export default __webpack_public_path__ + "static/media/truck-and-sign.3abad264.svg";